import theme from '../rainbowRich';

const primaryColor = theme.palette.nav.menuBg;

const variable = {
  primaryColor,
  primaryColorHighlight: 'rgba(107, 72, 157, 0.4)',
  primaryColorHighlightSolid: '#7f5cb1',
  callBtnColor: '#3C9949',
  c2dArrowColor: '#ffffff',
  addMeetingBtnColor: primaryColor,
  addMeetingBtnTextColor: '#FFFFFF',
  brandFontColor: primaryColor,
  brandFontColorHighlight: 'rgba(107, 72, 157, 0.4)',
  smsBubbleBackgroundColor: '#F3F3F3',
};

export default variable;
